import React from "react";

interface FinalPhaseTabProps {
  downloadMode: boolean;
  onHome: () => void;
}

const FinalPhaseTab: React.FC<FinalPhaseTabProps> = ({ downloadMode, onHome }) => {
  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">Policy</h2>
      <div className="space-y-4">
        <div className="border border-green-200 rounded-md px-3 py-2 text-green-700 text-sm">
          Work Flow completed successfully! The policy has been{" "}
          {downloadMode ? "downloaded" : "pushed to Git"}.
        </div>
        <div className="flex gap-2">
          <button
            className="px-4 py-2 text-white rounded bg-primary"
            onClick={onHome}
          >
            Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinalPhaseTab;
